module.exports = __webpack_public_path__ + "img/banner-index.5e206715.png";